import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { MdChevronRight, MdLocationOn, MdPhone } from 'react-icons/md';
import { formatUKTel } from '../../lib/helpers-telephone';
import SectionedList from '../../components/SectionedList';
import './styles.scss';

export default class Suppliers extends Component {

  renderSectionHeader = (sectionHeaderText) => {
    return (
      <div className="suppliers-list__section-title">{sectionHeaderText}</div>
    );
  }

  renderRow = (rowData, rowKey) => {
    const companyName = rowData.companyName || 'Unnamed supplier';
    const address = [rowData.address1, rowData.city, rowData.postcode].filter(Boolean).join(', ');
    const phone = rowData.mainTelephone ? formatUKTel(rowData.mainTelephone) : '';
    const hasLogo = typeof rowData.logoUrl === 'string' && /^https?:\/\//i.test(rowData.logoUrl);

    return (
      <button
        key={rowData.supplierKey || rowKey}
        type="button"
        className="supplier-card"
        onClick={() => this.props.openSupplierModal(rowData.supplierKey)}
      >
        <span className="supplier-card__identity" aria-hidden="true">
          {hasLogo ?
            <img className="supplier-card__logo" src={rowData.logoUrl} alt="" /> :
            companyName.charAt(0).toUpperCase()
          }
        </span>
        <span>
          <span className="supplier-card__name">{companyName}</span>
          <span className="supplier-card__meta">
            <span className="supplier-card__meta-item">
              <MdPhone />
              {phone || 'No phone number'}
            </span>
            <span className="supplier-card__meta-item">
              <MdLocationOn />
              {address || 'No address provided'}
            </span>
          </span>
        </span>
        <MdChevronRight className="supplier-card__open-icon" aria-hidden="true" />
      </button>
    );
  }

  render() {
    return (
      <div className="suppliers-list">
        <SectionedList
          data={this.props.suppliersData}
          getSectionHeaderText={value => (value === '_UNSORTABLE' ? 'Other suppliers' : `Tier ${value}`)}
          handleRowClicked={this.props.openSupplierModal}
          renderRow={this.renderRow}
          renderSectionHeader={this.renderSectionHeader}
          sectionSortProperty="tier"
          sectionSortOrder="ascending"
          rowSortProperty="companyName"
          rowSortOrder="ascending"
        />
      </div>
    );
  }
}

const { object, func } = PropTypes;

Suppliers.propTypes = {
  suppliersData: object,
  openSupplierModal: func.isRequired,
};

Suppliers.defaultProps = {
  suppliersData: {},
};
